export const rules = {
	// Card titles
	"rules.card.rules.title": "Regeln",
	"rules.card.goals.title": "Tore",
	"rules.card.cleanSheets.title": "Zu Null",
	"rules.card.cards.title": "Karten",
	"rules.card.misc.title": "Verschiedenes",
	"rules.card.captains.title": "Kapitäne & Vize-Kapitäne",
	"rules.card.eligibility.title": "Berechtigung & Preise",
	"rules.card.weeklyPrizes.title": "Wöchentliche Preisstruktur",
	"rules.card.finalRules.title": "Preisverteilung & Gleichstandsregelung",

	// Main rules content
	"rules.intro":
		'Alle großgeschriebenen Begriffe, die in diesen Regeln (den <strong>"Regeln"</strong>) verwendet werden, tragen die Definition, die ihnen in den Allgemeinen Geschäftsbedingungen (den <strong>"Allgemeinen Geschäftsbedingungen"</strong>) zugeschrieben wird.',

	"rules.rule1":
		"Teilnehmer können jede Woche/Runde (je nach Fall) ihr bestes Team auswählen, das für den Wettbewerb relevant ist, auf den sich das Betway Scores BW Fantasy Football-Spiel bezieht, z.B. English Premier League, etc. Der Betway Scores BW Fantasy Football-Wettbewerb beginnt am 11. März 2025 und endet am Ende der Fußballsaison 2025/2026.",

	"rules.rule2": "Jede Woche/Runde korreliert mit den Runden dieser Liga.",

	"rules.rule3":
		"Teilnehmer können maximal zwei (2) Spieler pro teilnehmender Liga-Mannschaft auswählen, um sie jede Woche/Runde in ihr Betway Scores BW Fantasy Football-Team aufzunehmen.",

	"rules.rule4":
		"Teilnehmer müssen jede Woche/Runde aktiv ihr Team auswählen, mit der Option, Änderungen vorzunehmen oder dasselbe Team für die folgende Woche/Runde beizubehalten.",

	"rules.rule5":
		"Punkte werden wie folgt für jede der folgenden Aktionen vergeben, die von den Spielern ausgeführt werden, die der Teilnehmer jede Woche/Runde in seinem Betway Scores BW Fantasy Football-Team auswählt:",

	// Goals points
	"rules.goals.forwardGoals": "Stürmertore",
	"rules.goals.forwardGoalsValue": "4",
	"rules.goals.midfielderGoals": "Mittelfeldspieler-Tore",
	"rules.goals.midfielderGoalsValue": "5",
	"rules.goals.defenderGoals": "Verteidiger-Tore",
	"rules.goals.defenderGoalsValue": "10",
	"rules.goals.goalkeeperGoals": "Torwart-Tore",
	"rules.goals.goalkeeperGoalsValue": "20",
	"rules.goals.penaltyGoals": "Elfmetertore",
	"rules.goals.penaltyGoalsValue": "3",
	"rules.goals.ownGoals": "Eigentore",
	"rules.goals.ownGoalsValue": "-5",
	"rules.goals.concededGoals": "Kassierte Tore",
	"rules.goals.concededGoalsValue": "-1",

	// Clean sheets points
	"rules.cleanSheets.goalkeeperCleanSheet": "Torwart zu Null",
	"rules.cleanSheets.goalkeeperCleanSheetValue": "5",
	"rules.cleanSheets.defenderCleanSheet": "Verteidiger zu Null",
	"rules.cleanSheets.defenderCleanSheetValue": "5",
	"rules.cleanSheets.midfielderCleanSheet": "Mittelfeldspieler zu Null",
	"rules.cleanSheets.midfielderCleanSheetValue": "1",

	// Cards points
	"rules.cards.yellowCard": "Gelbe Karten",
	"rules.cards.yellowCardValue": "-2",
	"rules.cards.redCard": "Rote Karten",
	"rules.cards.redCardValue": "-5",

	// Misc points
	"rules.misc.assists": "Vorlagen",
	"rules.misc.assistsValue": "4",
	"rules.misc.shotsOnTarget": "Schüsse aufs Tor",
	"rules.misc.shotsOnTargetValue": "1",
	"rules.misc.tackles": "Tacklings",
	"rules.misc.tacklesValue": "2",
	"rules.misc.saves": "Paraden",
	"rules.misc.savesValue": "1",
	"rules.misc.minutesOver60": "Gespielte Minuten gleich oder über 60",
	"rules.misc.minutesOver60Value": "2",
	"rules.misc.minutesUnder60": "Gespielte Minuten unter 60",
	"rules.misc.minutesUnder60Value": "1",
	"rules.misc.penaltyWon": "Elfmeter herausgeholt",
	"rules.misc.penaltyWonValue": "3",
	"rules.misc.penaltiesConceded": "Elfmeter verschuldet",
	"rules.misc.penaltiesConcededValue": "-3",
	"rules.misc.penaltyMissed": "Elfmeter verschossen",
	"rules.misc.penaltyMissedValue": "-3",
	"rules.misc.offsides": "Abseits",
	"rules.misc.offsidesValue": "-1",
	"rules.misc.foulsCommitted": "Begangene Fouls",
	"rules.misc.foulsCommittedValue": "-1",

	// Captain rules
	"rules.rule6":
		'Teilnehmer können einen <strong>"Kapitän"</strong> für ihr Team bestimmen, der 3x Punkte erhält. Der Kapitän kann jede Woche/Runde geändert werden. Ob der Kapitän für die folgende Woche/Runde geändert oder beibehalten wird, muss jede Woche/Runde vom Teilnehmer aktiv ausgewählt werden.',

	"rules.rule7":
		'Teilnehmer können einen <strong>"Vize-Kapitän"</strong> für ihr Team bestimmen, der 2x Punkte erhält. Der Vize-Kapitän kann jede Woche/Runde geändert werden. Ob der Vize-Kapitän für die folgende Woche/Runde geändert oder beibehalten wird, muss jede Woche vom Teilnehmer aktiv ausgewählt werden.',

	// Eligibility and prizes
	"rules.rule8":
		"Alle angemeldeten Betway Scores und/oder BW Scores Benutzer sind berechtigt, BW Fantasy Football zu spielen, jedoch sind nur Teilnehmer mit einem verifizierten Betway-Konto zum Zeitpunkt der Preisverleihung berechtigt, Preise zu gewinnen. Änderungen an den Rundenergebnissen gemäß Punkt 2. oben (die die Punkte unter 5. oben beeinflussen), die nach der Preisverleihung auftreten (z.B. Annullierung von Spielergebnissen), werden nicht rückwirkend berücksichtigt.",

	"rules.rule9":
		"Der qualifizierte und berechtigte Teilnehmer, der die Saison auf dem ersten Platz beendet und ein Betway-Wettkonto hat, wird der Hauptpreisgewinner der Saison sein und eine Reise für zwei (2) Personen gewinnen, um Arsenal in London spielen zu sehen, einschließlich Flügen (falls erforderlich), Unterkunft (falls erforderlich) und £500 Taschengeld.",

	"rules.rule10":
		"Wenn der Hauptpreisgewinner der Saison nicht reisen kann, weil er keinen gültigen Reisepass und/oder Visa und/oder andere Einschränkungen hat, erhält er einen Preis von €5.000 Barguthaben oder den ungefähren Gegenwert in lokaler Währung zum Wettbewerbsbeginn (£4.500, R100.000 oder GH₵ 60.000) auf sein Betway-Konto nach Abschluss des Wettbewerbs.",

	"rules.rule11":
		"Der Hauptpreisgewinner der Saison kann sich entscheiden, das Erlebnis nicht anzunehmen und stattdessen einen Preis von €5.000 Barguthaben oder den ungefähren Gegenwert in lokaler Währung zum Wettbewerbsbeginn (£4.500, R100.000 oder GH₵ 60.000) auf sein Betway-Konto zu akzeptieren.",

	"rules.rule12":
		"Wöchentliche Preise werden an die Top 10 Performer jede Woche/Runde vergeben, die ein gültiges Betway-Wettkonto haben. Wenn ein Top 10 Performer kein Betway-Wettkonto hat, wird ihm kein wöchentlicher Preis verliehen.",

	"rules.rule13": "Die wöchentlichen Plätze 1 bis 10 gewinnen die folgenden Barguthaben-Beträge, je nach Region, auf ihr Betway-Konto:",

	// Weekly prize table headers
	"rules.weeklyPrizes.position": "Position Pro Runde",
	"rules.weeklyPrizes.eur": "Barguthaben-Gewinne (EUR)",
	"rules.weeklyPrizes.gbp": "Barguthaben-Gewinne (GBP)",
	"rules.weeklyPrizes.zar": "Barguthaben-Gewinne (ZAR)",
	"rules.weeklyPrizes.ghs": "Barguthaben-Gewinne (GHS)",

	// Weekly prize values
	"rules.weeklyPrizes.1st.eur": "€150",
	"rules.weeklyPrizes.1st.gbp": "£150",
	"rules.weeklyPrizes.1st.zar": "R3000",
	"rules.weeklyPrizes.1st.ghs": "GH₵ 2000",

	"rules.weeklyPrizes.2nd.eur": "€100",
	"rules.weeklyPrizes.2nd.gbp": "£100",
	"rules.weeklyPrizes.2nd.zar": "R2000",
	"rules.weeklyPrizes.2nd.ghs": "GH₵ 1250",

	"rules.weeklyPrizes.3rd.eur": "€75",
	"rules.weeklyPrizes.3rd.gbp": "£75",
	"rules.weeklyPrizes.3rd.zar": "R1500",
	"rules.weeklyPrizes.3rd.ghs": "GH₵ 1000",

	"rules.weeklyPrizes.4th.eur": "€50",
	"rules.weeklyPrizes.4th.gbp": "£50",
	"rules.weeklyPrizes.4th.zar": "R1000",
	"rules.weeklyPrizes.4th.ghs": "GH₵ 600",

	"rules.weeklyPrizes.5th.eur": "€40",
	"rules.weeklyPrizes.5th.gbp": "£40",
	"rules.weeklyPrizes.5th.zar": "R800",
	"rules.weeklyPrizes.5th.ghs": "GH₵ 500",

	"rules.weeklyPrizes.6th.eur": "€30",
	"rules.weeklyPrizes.6th.gbp": "£30",
	"rules.weeklyPrizes.6th.zar": "R600",
	"rules.weeklyPrizes.6th.ghs": "GH₵ 400",

	"rules.weeklyPrizes.7th.eur": "€20",
	"rules.weeklyPrizes.7th.gbp": "£20",
	"rules.weeklyPrizes.7th.zar": "R400",
	"rules.weeklyPrizes.7th.ghs": "GH₵ 250",

	"rules.weeklyPrizes.8th.eur": "€15",
	"rules.weeklyPrizes.8th.gbp": "£15",
	"rules.weeklyPrizes.8th.zar": "R300",
	"rules.weeklyPrizes.8th.ghs": "GH₵ 200",

	"rules.weeklyPrizes.9th.eur": "€10",
	"rules.weeklyPrizes.9th.gbp": "£10",
	"rules.weeklyPrizes.9th.zar": "R200",
	"rules.weeklyPrizes.9th.ghs": "GH₵ 100",

	"rules.weeklyPrizes.10th.eur": "€10",
	"rules.weeklyPrizes.10th.gbp": "£10",
	"rules.weeklyPrizes.10th.zar": "R200",
	"rules.weeklyPrizes.10th.ghs": "GH₵ 100",

	// Final rules
	"rules.rule14":
		"Die wöchentlichen Preise werden innerhalb von 7 (sieben) Tagen nach Finalisierung der Ergebnisse dieser Woche vergeben und der Hauptpreis wird innerhalb von 7 (sieben) Tagen nach Abschluss des Betway Scores BW Fantasy Football-Wettbewerbs vergeben.",

	"rules.rule15":
		"Im Falle eines Gleichstands bei den wöchentlichen Preisen wird das Barguthaben für diese Position (und die relevanten Positionen darunter, die vom Gleichstand betroffen sind) gleichmäßig zwischen den punktgleichen Teilnehmern aufgeteilt.",

	"rules.rule16":
		"Im Falle eines Gleichstands um den Hauptpreis wird ein Zufallsmechanismus verwendet, um nur einen der punktgleichen Teilnehmer als Gewinner des Hauptpreises auszuwählen.",

	"rules.temporary_notice":
		"Bitte beachten Sie, dass Preisgewinner im Zeitraum vom 19. Dezember 2025 bis 2. Januar 2026 ihre Preise innerhalb von 7 (sieben) Tagen ab dem 6. Januar 2026 erhalten werden",
};
